import { useSyncExternalStore } from 'react';

function subscribeToHydration() {
  return () => {};
}

// The server and the first hydration render use the prerendered state.
export default function useHasHydrated() {
  return useSyncExternalStore(
    subscribeToHydration,
    () => true,
    () => false,
  );
}
